import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider as AlertProvider } from 'react-alert';

import reportWebVitals from './reportWebVitals';

import { AlertOptions } from './layout/AlertTemplate';
import { App } from './App';

import './i18n/i18n';

import { initializeIcons } from '@fluentui/react/lib/Icons';
import { initializeFileTypeIcons } from '@fluentui/react-file-type-icons';

import AuthState from './hooks/useAuthState';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.scss';

const { NODE_ENV } = process.env;

// https redirect
if (NODE_ENV === 'production' && document.location.protocol !== 'https:') {
  document.location.replace(`https:${document.location.href.substring(document.location.protocol.length)}`);
}
initializeIcons();
initializeFileTypeIcons();
ReactDOM.render(
  <React.StrictMode>
    <AlertProvider {...AlertOptions}>
      <AuthState>
        <BrowserRouter basename={NODE_ENV === 'production' ? 'app' : undefined}>
          <App />
          <ToastContainer
            position='top-center'
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='colored'
          />
        </BrowserRouter>
      </AuthState>
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
